import { render } from "./DragNDrop.vue?vue&type=template&id=1585d0e0&scoped=true"
import script from "./DragNDrop.vue?vue&type=script&lang=js"
export * from "./DragNDrop.vue?vue&type=script&lang=js"

import "./DragNDrop.vue?vue&type=style&index=0&id=1585d0e0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1585d0e0"]])

export default __exports__